import CircularCenteredLoader from "./CircularCenteredLoader";

export default CircularCenteredLoader;
